import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { fetchStats } from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";

const FALLBACK = {
  studies_completed: 312,
  active_partners: 47,
  publications: 89,
  researchers: 24,
  established: 2014,
};

function CountUp({ to }) {
  const [n, setN] = useState(0);
  useEffect(() => {
    let raf;
    const start = performance.now();
    const dur = 1400;
    const step = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * to));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [to]);
  return <span>{n.toLocaleString()}</span>;
}

export default function Stats() {
  const [s, setS] = useState(FALLBACK);
  const { t } = useLang();

  useEffect(() => {
    fetchStats().then(setS).catch(() => setS(FALLBACK));
  }, []);

  const items = [
    { label: t.stats.studies_completed, value: s.studies_completed, key: "studies" },
    { label: t.stats.active_partners, value: s.active_partners, key: "partners" },
    { label: t.stats.publications, value: s.publications, key: "publications" },
    { label: t.stats.researchers, value: s.researchers, key: "researchers" },
  ];

  return (
    <section
      data-testid="stats-section"
      className="relative border-b border-white/10 bg-[#0a0a0c]"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-20">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10"
        >
          {items.map((it) => (
            <div
              key={it.key}
              data-testid={`stat-${it.key}`}
              className="bg-[#0a0a0c] p-8 lg:p-12"
            >
              <div className="font-display font-bold text-5xl lg:text-7xl text-white tracking-tight">
                <CountUp to={it.value} />
                <span className="text-[#FF3333]">.</span>
              </div>
              <div className="mt-4 font-mono text-[10px] tracking-widest uppercase text-white/40">
                {it.label}
              </div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
